import { render } from "./ModelingRequestForm.vue?vue&type=template&id=ed197dee&scoped=true"
import script from "./ModelingRequestForm.vue?vue&type=script&lang=js"
export * from "./ModelingRequestForm.vue?vue&type=script&lang=js"

import "./ModelingRequestForm.vue?vue&type=style&index=0&id=ed197dee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed197dee"]])

export default __exports__